
















































































































import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import {SelectWings, NumberWings} from 'wings-ui-components';
import {DuplicateItem, DuplicateItemImpl} from '@/store/settings/duplicates/types';
import { notifyConfirm, notifyDelete, notifyError } from '@/utils/notify-helper';
import { TransportItem } from '@/store/transport/types';
import { ActionLog } from "@/store/auth/types";
import { getTranslatedParams } from "@/utils/notify-utils";
import { MsgTransports } from "@/store/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {SelectWings, NumberWings},
})
export default class Duplicate extends Vue {
  @Ref('validator') validator: any;

  @Action('getTransports') actionGetTransports: any;
  @Action('getPartners') actionGetPartners: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action('getDuplicateItem') actionGetItem: any;
  @Action('saveDuplicate') actionSave: any;
  @Action('deleteDuplicate') actionDelete: any;
  @Action("actionLog") actionLog: any;
  @Getter('transports') transportsList!: TransportItem[];

  private item = new DuplicateItemImpl();
  private itemSaved = new DuplicateItemImpl();
  private logObject: ActionLog = {};

  partnersList: any = []
  templatesList: any = []

  async getPartnersList(filter: any) {
    if (!this.item.channel_id) return
    const items = await this.actionGetPartners({transport: this.selectedTransport?.name, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getTemplatesList(filter: any) {
    if (!this.item.partner_id) return
    const items = await this.actionGetTemplates({transport: this.selectedTransport?.name, filter: {partner_id: this.item.partner_id, ...filter}});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  async created(): Promise<void> {
    try {
      await this.actionGetTransports();
      if (this.$route.params.id) {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "SMPP connection",
          addititional_info: getTranslatedParams(this.item)
        }
        const data = await this.actionGetItem(this.$route.params.id)
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        await this.actionLog(this.logObject);
        if (this.item.partner_id) this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
        if (this.item.template_id) this.templatesList = await this.actionGetTemplates({transport: this.selectedTransport?.name, filter: {id: this.item.template_id}});
      }
    } catch (error) {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  get transportsForDuplicatesList(): TransportItem[] {
    const validTransports = new Set<string>([
      MsgTransports.SMS,
      MsgTransports.VIBER,
      MsgTransports.PUSH,
      MsgTransports.WHATSAPP,
      MsgTransports.EMAIL,
      MsgTransports.MAILNOTIFY,
      MsgTransports.CUSTOM,
    ]);

    return this.transportsList.filter((t: TransportItem) => validTransports.has(t.name));
  }

  get selectedTransport(): TransportItem|undefined {
    return this.transportsList.find((t: TransportItem) => t.id === this.item.channel_id);
  }

  back(): void {
    this.$router.push('/settings/duplicates/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "SMPP connection",
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "SMPP connection",
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  @Watch('item.channel_id')
  onChannelChanged(val?: string, oldVal?: string) {
    if (oldVal && val !== oldVal) {
      this.item.partner_id = undefined;
      this.item.template_id = undefined;
    }
  }

  @Watch('item.partner_id')
  onPartnerChanged(val?: string, oldVal?: string) {
    if (oldVal && val !== oldVal) {
      this.item.template_id = undefined;
    }
  }
}
